export function parseTimestamp(value: unknown): string | null {
  if (value === undefined || value === null || value === '') return null;

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString();
  }

  if (typeof value === 'number' && Number.isFinite(value)) {
    const milliseconds = value < 10_000_000_000 ? value * 1000 : value;
    const date = new Date(milliseconds);
    return Number.isNaN(date.getTime()) ? null : date.toISOString();
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;

    if (/^\d+$/.test(trimmed)) {
      return parseTimestamp(Number(trimmed));
    }

    const date = new Date(trimmed);
    return Number.isNaN(date.getTime()) ? null : date.toISOString();
  }

  return null;
}

export function minutesBetween(startIso: string, endIso: string): number {
  return Math.max(0, (Date.parse(endIso) - Date.parse(startIso)) / 60_000);
}

export function toLocalDateKey(iso: string): string {
  const date = new Date(iso);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatDateTime(iso: string): string {
  return new Intl.DateTimeFormat('ja-JP', {
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso));
}

export function overlapsDateRange(
  startIso: string,
  endIso: string,
  range: { start?: string; end?: string },
): boolean {
  const start = Date.parse(startIso);
  const end = Date.parse(endIso);
  const rangeStart = range.start ? Date.parse(`${range.start}T00:00:00`) : Number.NEGATIVE_INFINITY;
  const rangeEnd = range.end ? Date.parse(`${range.end}T23:59:59.999`) : Number.POSITIVE_INFINITY;
  return end >= rangeStart && start <= rangeEnd;
}

export function isNightStay(startIso: string, endIso: string): boolean {
  const start = new Date(startIso);
  const end = new Date(endIso);
  for (let time = start.getTime(); time <= end.getTime(); time += 60 * 60 * 1000) {
    const hour = new Date(time).getHours();
    if (hour >= 22 || hour < 6) return true;
  }
  return false;
}
